import React from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import ActionTemplate from './SidebarActionTemplate';

import style from './style';

function HamburgerMenuSidebarAction({
  classes,
  children,
  isOpen,
  onClose,
  onClick,
}) {
  return (
    <ActionTemplate
      classes={classes}
      handleClick={onClick}
      handleClose={() => onClose()}
      icon={<MoreVertIcon className={classes.icon} />}
      isOpen={isOpen}
      mouseEvent="onMouseDown"
    >
      <Paper className={classes.dropdown}>
        <MenuList
          className={`${classes.action__menuList} ${classes.action__menuList_hamburger}`}
          role="menu"
        >
          {children}
        </MenuList>
      </Paper>
    </ActionTemplate>
  );
}

HamburgerMenuSidebarAction.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(style)(HamburgerMenuSidebarAction);
